VLW.IntroBureau = class extends VLW.classBase {
	constructor() {
		super();
		TweenMax.delayedCall(0,this.launch);

	}
	launch(){
		let tl = new TimelineMax();
		tl.add(this.logo(), 0);

	}
	logo(){
		return (CONFIG.ISTABLET===true || VERSION_SMARTP) ?this.logo_tablet():this.logo_bureau();
		
		
	}
	logo_tablet(){
		
		
		
		let tl  = new TimelineMax();
		let _b  = ([...document.querySelectorAll("._mainLogo")]);
		tl.timeScale(CONFIG.INTRO_TIMESCALE);
		tl.to(_b,2,  {opacity: 1, ease: Sine.easeIn});
		tl.to(_b, 1.5, {scale: 1, opacity: 0, ease: Sine.easeInOut,display:"none"}, 4.5);
		return tl;
	}
	logo_bureau(){
		let tl  = new TimelineMax();
		let _da  = ([...document.querySelectorAll("._mainLogo .da")]);
		let _ar  = ([...document.querySelectorAll("._mainLogo .arlot")]);
		let _do  = ([...document.querySelectorAll("._mainLogo .domaine")]);
		let _b   = ([...document.querySelectorAll("._mainLogo")]);
		tl.timeScale(CONFIG.INTRO_TIMESCALE);
		tl.set([_da,_ar,_do],{opacity:0});
		tl.set(_b,{opacity: 1,scale:4.5});
		tl.to(_da,2 ,{opacity: 1,ease:Sine.easeIn},0);
		tl.to(_do,2 ,{opacity: 1,ease:Sine.easeIn},2);
		tl.to(_ar,2 ,{opacity: 1,ease:Sine.easeIn},2);
		tl.to(_b	,1,{opacity:0,ease:Sine.easeInOut,display:"none"}		,4);
		return tl;
	}
};
